<template>
    <picture v-if="src" class="contents">
        <source :srcset="avifSources.srcset" type="image/avif" />
        <source :srcset="webpSources.srcset" type="image/webp" />
        <img
            v-bind="imgAttrs"
            :src="webpSources.src"
            :srcset="webpSources.srcset"
            :width="width"
            :height="height" />
    </picture>
</template>

<script setup lang="ts">
    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        src: string;
        /** Layout width in CSS pixels. CDN requests use 1x and 2x variants automatically. */
        width: number;
        height?: number;
        quality?: number;
    }

    const props = withDefaults(defineProps<Props>(), {
        quality: 90,
    });

    const attrs = useAttrs();

    const imgAttrs = computed(() => {
        const { src: _src, srcset: _srcset, width: _width, height: _height, ...rest } = attrs;
        return rest;
    });

    const avifSources = computed(() =>
        useShopwareImageSrcSet(props.src, {
            width: props.width,
            quality: props.quality,
            format: 'avif',
        }),
    );

    const webpSources = computed(() =>
        useShopwareImageSrcSet(props.src, {
            width: props.width,
            quality: props.quality,
            format: 'webp',
        }),
    );
</script>
